import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';

import { formatNumber } from '../../../helpers';
import { formatBytes } from '../../../helpers/Files';

const getPieChartOptions = (id, labels, formatter) => ({
  chart: {
    id,
    toolbar: {
      show: false,
    },
    height: '100%',
  },
  colors: [
    '#28c29a',
    '#00b9b5',
    '#00adcb',
    '#009fd8',
    '#008dd8',
    '#4b80d6',
    '#7370cc',
    '#925ebb',
    '#ba4b9d',
    '#d03e76',
    '#d4434d',
    '#c75522',
  ],
  labels,
  tooltip: {
    x: {
      formatter,
    },
  },
  theme: {
    monochrome: {
      enabled: false,
      color: '#28c29b',
    },
  },
});

const AdminReportsCartPie = ({ report, data }) => (
  <Chart
    options={getPieChartOptions(
      report.id,
      data.map(d => (d.label)),
      v => (report.formatter === 'number' ? formatNumber(v) : formatBytes(v)),
    )}
    series={data.map(d => (d.count))}
    type={report.chartType}
    width="100%"
    height={300}
  />
);

AdminReportsCartPie.propTypes = {
  report: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
};

export default AdminReportsCartPie;
